import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import About from "./About";
import Search from "./Search";
import Occulus from "../components/Occulus";
import DataSquare from "../components/DataSquare";
import Loading from "../components/Loading";

import '../styles/index.scss'
import '../styles/animation.scss'
import '../styles/mobile.scss'

class Container extends React.Component {
    constructor(props) {
        super(props);
        this.state={
        loading: false,
        error: false, 
        unit: "celsius",
        display: "container",
        date: "",
        location: "",
        temp: "",
        fetch: "",
        current: "",
        timezone: "", 
        hourly: "",
        daily: "",
        dashboard: "current", 
        }
    this.position = this.position.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.getTime = this.getTime.bind(this);
    this.changeDisplay = this.changeDisplay.bind(this);
    this.aboutClick = this.aboutClick.bind(this);
    this.updateClick = this.updateClick.bind(this);
    };

    position() {
        //this provides the lat and lon for the API call 
        //I need to split this up
        //update button needs to only do "fetch", once location is found
        
        let lat;
        let lon; 
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            lat = position.coords.latitude;
            lon = position.coords.longitude;
            //primary weather data
            const weatherUrl =
                  `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&units=metric&appid=${process.env.REACT_APP_API_KEY}`;
            //location name
            const locationUrl = 
            `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${process.env.REACT_APP_API_KEY}`;
            
            //get weather data
            fetch(weatherUrl)
              .then((response) => response.json())
              .then((data) => {
                const hourlyDataset = [];
                data.hourly.forEach(item => {
                    const tempPair = [(item.dt*1000), item.temp, item.pop]
                    hourlyDataset.push(tempPair)
                })
                const dailyDataset = [];
                data.daily.forEach(item => {
                  const dailyData = {
                    date: item.dt,
                    hitemp: item.temp.max,
                    lowtemp: item.temp.min,
                    weathermain: item.weather[0].main,
                    weatherdesc: item.weather[0].description,
                    weathericon: item.weather[0].icon,
                  }
                  dailyDataset.push(dailyData)
                })
        
                this.setState({
                  loading: false,
                  fetch: [weatherUrl, lat, lon],
                  current: {
                    time: data.current.dt,
                    sunrise: data.current.sunrise,
                    sunset: data.current.sunset,
                    temp: data.current.temp,
                    humidity: data.current.humidity,
                    dewpoint: data.current.dew_point,
                    uvi: data.current.uvi,
                    clouds: data.current.clouds,
                    pressure: data.current.pressure,
                    visibility: data.current.visibility,
                    description: data.current.weather[0].main,
                    id: data.current.weather[0].id,
                    icon: data.current.weather[0].icon,
                    subdescription: data.current.weather[0].description, 
                    windspeed: data.current.wind_speed,
                    windvector: data.current.wind_deg,
                  },
                  daily: dailyDataset,
                  timezone: data.timezone_offset,
                  baseHourly: hourlyDataset.slice(0,24),
                  hourly: hourlyDataset.slice(0,24),
                });
              })
              .catch((err)=> {
                  console.log('Error!:'+err);
                  return this.setState({
                    loading: true,
                    error: true,
                  })
            });

            //get location name
            fetch(locationUrl)
              .then((response) => response.json())
              .then((data) => {
                this.setState({
                  location: data.name,
                })
              })
              .catch((err)=>{
                return this.setState({
                  loading: true,
                  error: true,
                })
              })
              
          });
        }
      }

    getTime(){
      const today = new Date();
      this.setState({
        date: {
          month: today.getMonth(),
          day: today.getDate(),
          hour: today.getHours(),
          minutes: today.getMinutes(),
          weekDay: today.getDay(),
        }
      })
    }

    componentDidMount(){
        this.setState({loading: true});
        this.position(); //identifies lat and lon
                         //get data, make API call
        this.getTime(); //gets current time
    }

    handleClick(){ //change from celsius to fahrenheit
      const celsiusHourly = this.state.baseHourly;
      const imperialHourly = [];
      celsiusHourly.forEach((item,index)=>{
        const fTemp = Math.round(item[1] * (9/5) + 32)
        const tempPair2 = [item[0], fTemp,item[2]]
        imperialHourly.push(tempPair2);
      });

      this.setState(prevState=>({
        unit: prevState.unit === "celsius" ? "fahrenheit" : "celsius",
        hourly: prevState.unit === "celsius" ? imperialHourly : this.state.baseHourly,
      })); 
    }

    changeDisplay(e){ //changes smaller dashboard display
      const displayArr = ["current", "hourly", "seven-day"];
      const id = e.target.id;
      if (id === "current"){
        this.setState({dashboard: displayArr[0]})
      }   
      if (id === "hourly"){
        this.setState({dashboard: displayArr[1]})
      }
      if (id === "seven-day"){
        this.setState({dashboard: displayArr[2]})
      }
      if (id==="scroll-right"){
        for(let i=0; i<displayArr.length; i++){
          if (this.state.dashboard === displayArr[i]){
            let newDisplay = displayArr[i+1];
            this.setState({
              dashboard: newDisplay
            })
          }
        }
      }
      if (id==="scroll-left"){
        for(let i=0; i<displayArr.length; i++){
          if (this.state.dashboard === displayArr[i]){
            let newDisplay = displayArr[i-1];
            this.setState({
              dashboard: newDisplay
            })
          }
        }
      }   
    }

    //initiates the about page
    aboutClick(e){
      const id = e.target.id;
      if (id==="about"){
        this.setState(prevState=>({
          display: "about"
          })
        )
      }
      if (id==="back-button"){
        this.setState({
          display: "container"
        })
      }
      if (id==="search"){
        console.log("worked");
        this.setState({
          display: "search"
        })
      }
      
    }

    //initiates the update
    updateClick(){
      this.setState({loading: true});
      this.position(); //identifies lat and lon
      this.getTime(); //gets current time
    }

    render(){
      const displayAbout = () => {
        if (this.state.display === "about" ){
          return <About onClick={this.aboutClick}/>
        }
        else if (this.state.display === "search"){
          console.log("worked");
          return <Search onClick={this.aboutClick}/>
        }
        else {
          return null;
        }
      }
        return(
            <div className="main">
                {displayAbout()}
                <Navbar onClick2={this.updateClick} onClick={this.aboutClick} page={this.state.display}/>
                
                {this.state.loading ? <Loading error={this.state.error} />: 
                <div className="container">
                  <Occulus 
                    date={this.state.date}
                    current={this.state.current}
                    id={this.state.id}
                    icon={this.state.icon}
                    unit={this.state.unit}/>
                  <DataSquare 
                    timezone={this.state.timezone}
                    date={this.state.date}
                    onClick={this.handleClick}
                    onClick2={this.changeDisplay}
                    current={this.state.current} 
                    data={this.state.hourly}
                    daily={this.state.daily}
                    location={this.state.location}
                    unit={this.state.unit}
                    dashboard={this.state.dashboard}/>
                </div>}
                <Footer onClick={this.aboutClick} page={this.state.display}/> 
            </div>
        )
    }
}

export default Container;